import { BlogPostContent } from '@/types/blog';
import { einleitung } from './sections/einleitung';
import { statistischeRealitaet } from './sections/statistische-realitaet';
import { aktivesManagement } from './sections/aktives-management';
import { behavioralGap } from './sections/behavioral-gap';
import { bigThree } from './sections/big-three';
import { emhBehavioral } from './sections/emh-behavioral';
import { deutschePerspektive } from './sections/deutsche-perspektive';
import { coreAndExplore } from './sections/core-and-explore';
import { fazit } from './sections/fazit';

export const content: BlogPostContent = {
  sections: [
    einleitung,
    statistischeRealitaet,
    aktivesManagement,
    behavioralGap,
    bigThree,
    emhBehavioral,
    deutschePerspektive,
    coreAndExplore,
    fazit
  ]
};
